const images = {
    'horizons': {
        'offer1': [
            require('./horizons/offer1/horizons_offer1_img.jpg'),
        ],
        'offer2': [
            require('./horizons/offer2/horizons_offer2_img.jpg'),
        ],
        'offer3': [
            require('./horizons/offer3/horizons_offer3_img.jpg'),
        ],
        'offer4': [
            require('./horizons/offer4/horizons_offer4_img.jpg'),
        ],
        'offer5': [
            require('./horizons/offer5/horizons_offer5_img.jpg'),
        ],
        'offer6': [
            require('./horizons/offer6/horizons_offer6_img.jpg'),
        ],
        'offer7': [
            require('./horizons/offer7/horizons_offer7_img.jpg'),
        ],
        'offer8': [
            require('./horizons/offer8/horizons_offer8_img.jpg'),
        ],
        'offer9': [
            require('./horizons/offer9/horizons_offer9_img.jpg'),
        ],
        'offer10': [
            require('./horizons/offer10/horizons_offer10_img.jpg'),
        ],
        'offer11': [
            require('./horizons/offer11/horizons_offer11_img.jpg'),
        ],
        'offer12': [
            require('./horizons/offer12/horizons_offer12_img.jpg'),
        ],
        'offer13': [
            require('./horizons/offer13/horizons_offer13_img.jpg'),
        ],
        'offer14': [
            require('./horizons/offer14/horizons_offer14_img.jpg'),
        ],
        'offer15': [
            require('./horizons/offer15/horizons_offer15_img.jpg'),
        ],
        'offer16': [
            require('./horizons/offer16/horizons_offer16_img.jpg'),
        ],
        'offer17': [
            require('./horizons/offer17/horizons_offer17_img.jpg'),
        ],
        'offer18': [
            require('./horizons/offer18/horizons_offer18_img.jpg'),
        ],
        'offer19': [
            require('./horizons/offer19/horizons_offer19_img.jpg'),
        ],
        'offer20': [
            require('./horizons/offer20/horizons_offer20_img.jpg'),
        ]        
    },
    'indulgence': {
        
        'offer21': [
            require('./indulgence/offer21/indulgence_offer1_img.jpg'),
        ],
        'offer1': [
            require('./indulgence/offer1/indulgence_offer1_img.jpg'),
        ],
        'offer2': [
            require('./indulgence/offer2/indulgence_offer2_img.jpg'),
        ],
        'offer3': [
            require('./indulgence/offer3/indulgence_offer3_img.jpg'),
        ],
        'offer4': [
            require('./indulgence/offer4/indulgence_offer4_img.jpg'),
        ],
        'offer5': [
            require('./indulgence/offer5/indulgence_offer5_img.jpg'),
        ],
        'offer6': [
            require('./indulgence/offer6/indulgence_offer6_img.jpg'),
        ],
        'offer7': [
            require('./indulgence/offer7/indulgence_offer7_img.jpg'),
        ],
        'offer8': [
            require('./indulgence/offer8/indulgence_offer8_img.jpg'),
        ],
        'offer9': [
            require('./indulgence/offer9/indulgence_offer9_img.jpg'),
        ],
        'offer10': [
            require('./indulgence/offer10/indulgence_offer10_img.jpg'),
        ],
        'offer11': [
            require('./indulgence/offer11/indulgence_offer11_img.jpg'),
        ],
        'offer12': [
            require('./indulgence/offer12/indulgence_offer12_img.jpg'),
        ],
        'offer13': [
            require('./indulgence/offer13/indulgence_offer13_img.jpg'),
        ],
        'offer14': [
            require('./indulgence/offer14/indulgence_offer14_img.jpg'),
        ],
        'offer15': [
            require('./indulgence/offer15/indulgence_offer15_img.jpg'),
        ],
        'offer16': [
            require('./indulgence/offer16/indulgence_offer16_img.jpg'),
        ],
        'offer17': [
            require('./indulgence/offer17/indulgence_offer17_img.jpg'),
        ],
        'offer18': [
            require('./indulgence/offer18/indulgence_offer18_img.jpg'),
        ],
        'offer19': [
            require('./indulgence/offer19/indulgence_offer19_img.jpg'),
        ],
        'offer20': [
            require('./indulgence/offer20/indulgence_offer20_img.jpg'),
        ]        
    },
    'balance': {
        'offer1': [
            require('./balance/offer1/balance_offer1_img.jpg'),
        ],
        'offer2': [
            require('./balance/offer2/balance_offer2_img.jpg'),
        ],
        
        'offer3': [
            require('./balance/offer3/balance_offer3_img.jpg'),
        ],
        'offer4': [
            require('./balance/offer4/balance_offer4_img.jpg'),
        ],
        'offer5': [
            require('./balance/offer5/balance_offer5_img.jpg'),
        ],
        'offer6': [
            require('./balance/offer6/balance_offer6_img.jpg'),
        ],
        'offer7': [
            require('./balance/offer7/balance_offer7_img.jpg'),
        ],
        'offer8': [
            require('./balance/offer8/balance_offer8_img.jpg'),
        ],
        'offer9': [
            require('./balance/offer9/balance_offer9_img.jpg'),
        ],
        'offer10': [
            require('./balance/offer10/balance_offer10_img.jpg'),
        ],
        'offer11': [
            require('./balance/offer11/balance_offer11_img.jpg'),
        ],
        'offer12': [
            require('./balance/offer12/balance_offer12_img.jpg'),
        ],
        'offer13': [
            require('./balance/offer13/balance_offer13_img.jpg'),
        ],
        'offer14': [
            require('./balance/offer14/balance_offer14_img.jpg'),
        ],
        'offer15': [
            require('./balance/offer15/balance_offer15_img.jpg'),
        ],
        'offer16': [
            require('./balance/offer16/balance_offer16_img.jpg'),
        ],
        'offer17': [
            require('./balance/offer17/balance_offer17_img.jpg'),
        ],
        'offer18': [
            require('./balance/offer18/balance_offer18_img.jpg'),
        ],
        'offer19': [
            require('./balance/offer19/balance_offer19_img.jpg'),
        ],
        'offer20': [
            require('./balance/offer20/balance_offer20_img.jpg'),
        ]        
    },
    'moments': {
        'offer1': [
            require('./moments/offer1/moments_offer1_img.jpg'),
        ],
        'offer2': [
            require('./moments/offer2/moments_offer2_img.jpg'),
        ],
        'offer3': [
            require('./moments/offer3/moments_offer3_img.jpg'),
        ],
        'offer4': [
            require('./moments/offer4/moments_offer4_img.jpg'),
        ],
        'offer5': [
            require('./moments/offer5/moments_offer5_img.jpg'),
        ],
        'offer6': [
            require('./moments/offer6/moments_offer6_img.jpg'),
        ],
        'offer7': [
            require('./moments/offer7/moments_offer7_img.jpg'),
        ],
        'offer8': [
            require('./moments/offer8/moments_offer8_img.jpg'),
        ],
        'offer9': [
            require('./moments/offer9/moments_offer9_img.jpg'),
        ],
        'offer10': [
            require('./moments/offer10/moments_offer10_img.jpg'),
        ],
        'offer11': [
            require('./moments/offer11/moments_offer11_img.jpg'),
        ],
        'offer12': [
            require('./moments/offer12/moments_offer12_img.jpg'),
        ],
        'offer13': [
            require('./moments/offer13/moments_offer13_img.jpg'),
        ],
        'offer14': [
            require('./moments/offer14/moments_offer14_img.jpg'),
        ],
        'offer15': [
            require('./moments/offer15/moments_offer15_img.jpg'),
        ],
        'offer16': [
            require('./moments/offer16/moments_offer16_img.jpg'),
        ],
        'offer17': [
            require('./moments/offer17/moments_offer17_img.jpg'),
        ],
        'offer18': [
            require('./moments/offer18/moments_offer18_img.jpg'),
        ],
        'offer19': [
            require('./moments/offer19/moments_offer19_img.jpg'),
        ],
        'offer20': [
            require('./moments/offer20/moments_offer20_img.jpg'),
        ],
        'offer21': [
            require('./moments/offer21/Sectionimageone.jpg'),
        ], 
        'offer22': [
            require('./moments/offer22/Sectionimagetwo.jpg'),
        ]  ,
        'offer23': [
            require('./moments/offer23/Sectionimagetwo.jpg'),
        ]     
    },
    'delights': {
        'offer1': [
            require('./delights/offer1/delights_offer1_img.jpg'),
        ],
        'offer2': [
            require('./delights/offer2/delights_offer2_img.jpg'),
        ],
        'offer3': [
            require('./delights/offer3/delights_offer3_img.jpg'),
        ],
        'offer4': [
            require('./delights/offer4/delights_offer4_img.jpg'),
        ],
        'offer5': [
            require('./delights/offer5/delights_offer5_img.jpg'),
        ],
        'offer6': [
            require('./delights/offer6/delights_offer6_img.jpg'),
        ],
        'offer7': [
            require('./delights/offer7/delights_offer7_img.jpg'),
        ],
        'offer8': [
            require('./delights/offer8/delights_offer8_img.jpg'),
        ],
        'offer9': [
            require('./delights/offer9/delights_offer9_img.jpg'),
        ],
        'offer10': [
            require('./delights/offer10/delights_offer10_img.jpg'),
        ],
        'offer11': [
            require('./delights/offer11/delights_offer11_img.jpg'),
        ],
        'offer12': [
            require('./delights/offer12/delights_offer12_img.jpg'),
        ],
        'offer13': [
            require('./delights/offer13/delights_offer13_img.jpg'),
        ],
        'offer14': [
            require('./delights/offer14/delights_offer14_img.jpg'),
        ],
        'offer15': [
            require('./delights/offer15/delights_offer15_img.jpg'),
        ],
        'offer16': [
            require('./delights/offer16/delights_offer16_img.jpg'),
        ],
        'offer17': [
            require('./delights/offer17/delights_offer17_img.jpg'),
        ],
        'offer18': [
            require('./delights/offer18/delights_offer18_img.jpg'),
        ],
        'offer19': [
            require('./delights/offer19/delights_offer19_img.jpg'),
        ],
        'offer20': [
            require('./delights/offer20/delights_offer20_img.jpg'),
        ]        
    },
    'rewards': {
        'offer1': [
            require('./rewards/offer1/rewards_offer1_img.jpg'),
        ],
        'offer2': [
            require('./rewards/offer1/rewards_offer2_img.jpg'),
        ],
        'highest': [
            require('./rewards/highest/rewards_highest_copy_img.jpg'),
        ]
    },
    'dedication': {
        'rm': [
            require('./dedication/rm/dedication_rm_img.jpg'),
        ]
    },
    "offers": {
        "airfare_privilege": require('./offers/airfare_privilege.jpg'),
        "airport_travel": require('./offers/airport_travel.jpg'),
        "annual_travel_protection": require('./offers/annual_travel_protection.jpg'),
        "complimentary_buggy_service_program": require('./offers/complimentary_buggy_service_program.jpg'),
        "car_rental": require('./offers/car_rental.jpg'),
        "car_rental_mc": require('./offers/car_rental_mc.jpg'),
        "global_purchase": require('./offers/global_purchase.jpg'),
        "hotel_privilege": require('./offers/hotel_privilege.jpg'),
        "hotel_privilege_mc": require('./offers/hotel_privilege_mc.jpg'),
        "limousine": require('./offers/limousine.jpg'),
        "priority_pass": require('./offers/priority_pass.jpg'),
        "other_offer": require('./offers/other_offer.jpg'),
        "other_travel_offer": require('./offers/other_travel_offer.jpg'),
        "other_dining_offer": require('./offers/other_dining_offer.jpg'),
        "other_shopping_offer": require('./offers/other_shopping_offer.jpg'),
        "delights_offer": require('./offers/delights_offer.jpg'),
        "gentry_club": require('./offers/gentry_club.jpg'),
        "eaton_club": require('./offers/eaton_club.jpg'),
        "yacht": require('./offers/yacht.jpg'),
        "dining_privileges": require('./offers/dining_privileges_at_regent_hongkong.jpg'),

    }
}

export default images;